import React from "react";
import { Link } from "react-router-dom";
import Tags from "./Tags";

export default function Blog({ blog }) {
  const { id, title, createdAt, image, likes, tags, isSaved } = blog || {};
  return (
    <div className="lws-card">
      <Link to={`post/${id}`}>
        <img
          src={image}
          className="lws-card-image"
          alt="Top Github Alternatives"
        />
      </Link>
      <div className="p-4">
        <div className="lws-card-header">
          <p className="lws-publishedDate">{createdAt}</p>
          <p className="lws-likeCount">
            <i className="fa-regular fa-thumbs-up"></i>
            {likes}
          </p>
        </div>
        <Link to={`/post/${id}`} className="lws-postTitle">
          {title}
        </Link>
        <Tags tags={tags} />
        {isSaved && (
          <div className="flex gap-2 mt-4">
            <span className="lws-badge"> Saved </span>
          </div>
        )}
      </div>
    </div>
  );
}
